import styled from "styled-components";
import { DownloadBg } from '@assets';
import { Space, Flex } from "antd";

export const RootContainer = styled.div`
  display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 100%;

  background: #FFFFFF;
`

export const TopImg = styled.div`
	width: 100% !important;

  aspect-ratio: 214 / 235 !important;

	background-image: url(${DownloadBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`

export const Title = styled.div`
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */

  margin-bottom: 16px;
`;

export const Wrapper = styled.div`
  width: 80%;
  margin: 8px auto;

  svg{
    width: 100%;
  }
`;

export const SimpleLink = styled.a`

`

export const SocialWrapper = styled(Flex)`
	gap: 15px !important;
  justify-content: center;
  align-items: center;
  margin: 0 auto 24px;

	svg {
		width: 40px;
		height: 40px;
	}
`;

export const DownloadWrapper = styled(Space).attrs({
	direction: "vertical",
})`
	gap: 15px !important;
	width: 100%;

  svg{
    width: 100%;
    height: auto;
  }
`;

export const Desc = styled.p`
  color: #2A2A2A;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */

  margin-bottom: 24px;
`